document.documentElement.classList.remove('no-js');

class QuantityInput extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('button').forEach((btn) => {
      btn.addEventListener('click', () => {
        const input = this.querySelector('input');
        const step = btn.dataset.step === 'up' ? 1 : -1;
        input.value = Math.max(1, parseInt(input.value || '1', 10) + step);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }
}
customElements.define('quantity-input', QuantityInput);

const header = document.querySelector('[data-header]');
const menuToggle = document.querySelector('[data-menu-toggle]');
const nav = document.querySelector('[data-primary-nav]');

if (header && menuToggle && nav) {
  let lastFocusedElement = null;

  function getFocusableNavItems() {
    return Array.prototype.slice.call(
      nav.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
    ).filter(function(el) {
      return el.offsetParent !== null;
    });
  }

  function setMenuState(isOpen) {
    header.classList.toggle('is-menu-open', isOpen);
    document.body.classList.toggle('menu-open', isOpen);
    menuToggle.setAttribute('aria-expanded', String(isOpen));
    menuToggle.setAttribute('aria-label', isOpen ? 'Close navigation menu' : 'Open navigation menu');

    if (isOpen) {
      lastFocusedElement = document.activeElement;
      const firstItem = getFocusableNavItems()[0];
      if (firstItem) firstItem.focus();
    } else if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus();
    }
  }

  menuToggle.setAttribute('aria-label', 'Open navigation menu');

  menuToggle.addEventListener('click', () => {
    setMenuState(!header.classList.contains('is-menu-open'));
  });

  nav.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => {
      setMenuState(false);
    });
  });

  document.addEventListener('click', (event) => {
    if (!header.classList.contains('is-menu-open')) return;
    if (!header.contains(event.target)) setMenuState(false);
  });

  document.addEventListener('keydown', (event) => {
    if (!header.classList.contains('is-menu-open')) return;

    if (event.key === 'Escape') {
      setMenuState(false);
      return;
    }

    if (event.key === 'Tab') {
      const focusable = getFocusableNavItems();
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });
}


// Product page enhancements: variant pills, gallery swap and quantity steppers
(function(){
  document.querySelectorAll('[data-product-form]').forEach(function(form){
    var select = form.querySelector('[data-product-variant-select]');
    var radios = form.querySelectorAll('[data-variant-radio]');
    var price = document.querySelector('[data-product-price]');
    var compare = document.querySelector('[data-compare-price]');
    var sku = document.querySelector('[data-product-sku]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var addToCart = form.querySelector('[data-add-to-cart-button]');
    var stickyBtn = document.querySelector('.pdp-sticky-cta__btn');
    var mainImage = document.querySelector('[data-product-main-image]');
    function applyVariant(el){
      if (!el) return;
      if (select) select.value = el.value;
      if (window.history && window.history.replaceState && el.value) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', el.value);
        window.history.replaceState({}, '', url.toString());
      }
      var priceText = el.dataset.price || '';
      var compareText = el.dataset.comparePrice || '';
      var available = el.dataset.available === 'true';
      if (price && priceText) price.textContent = priceText;
      if (stickyPrice && priceText) stickyPrice.textContent = priceText;
      if (compare) {
        if (compareText && compareText !== '$0.00' && compareText !== '') {
          compare.textContent = compareText;
          compare.style.display = '';
        } else {
          compare.textContent = '';
          compare.style.display = 'none';
        }
      }
      if (sku) {
        if (el.dataset.sku) {
          sku.textContent = 'SKU: ' + el.dataset.sku;
          sku.style.display = '';
        } else {
          sku.style.display = 'none';
        }
      }
      [addToCart, stickyBtn].forEach(function(btn){
        if (!btn) return;
        btn.disabled = !available;
        btn.setAttribute('aria-disabled', String(!available));
        btn.textContent = available ? (btn.dataset.availableText || 'Add to cart') : (btn.dataset.soldOutText || 'Sold out');
      });
      if (mainImage && el.dataset.image) {
        mainImage.src = el.dataset.image;
        if (el.dataset.imageAlt) mainImage.alt = el.dataset.imageAlt;
      }
    }
    radios.forEach(function(radio){
      radio.addEventListener('change', function(){ if (radio.checked) applyVariant(radio); });
    });
    if (select) {
      select.addEventListener('change', function(){
        var match = form.querySelector('[data-variant-radio][value="' + select.value + '"]');
        if (match) { match.checked = true; applyVariant(match); }
      });
    }
    var checked = form.querySelector('[data-variant-radio]:checked');
    if (checked) applyVariant(checked);
  });

  document.querySelectorAll('[data-gallery-image]').forEach(function(link){
    link.addEventListener('click', function(event){
      var mainImage = document.querySelector('[data-product-main-image]');
      if (!mainImage) return;
      event.preventDefault();
      mainImage.src = link.getAttribute('data-gallery-image');
      var alt = link.getAttribute('data-gallery-alt');
      if (alt) mainImage.alt = alt;
    });
  });
})();


// Product lightbox and stronger gallery behaviour
(function(){
  var lightbox = document.querySelector('[data-product-lightbox]');
  var lightboxImg = document.querySelector('[data-lightbox-target]');
  var closeBtn = document.querySelector('[data-close-lightbox]');
  var mainImg = document.querySelector('[data-product-main-image]');
  var lastTrigger = null;

  function getFocusableElements(){
    if (!lightbox) return [];
    return Array.prototype.slice.call(lightbox.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'));
  }

  function openLightbox(event){
    if (!lightbox || !lightboxImg || !mainImg) return;
    lastTrigger = event && event.currentTarget ? event.currentTarget : document.activeElement;
    lightboxImg.src = mainImg.currentSrc || mainImg.src;
    lightboxImg.alt = mainImg.alt || '';
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.classList.add('lightbox-open');
    if (closeBtn) closeBtn.focus();
  }

  function closeLightbox(){
    if (!lightbox || lightbox.getAttribute('aria-hidden') === 'true') return;
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('lightbox-open');
    if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
  }

  document.querySelectorAll('[data-open-lightbox]').forEach(function(btn){
    btn.addEventListener('click', openLightbox);
  });
  if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
  if (lightbox) {
    lightbox.addEventListener('click', function(event){
      if (event.target === lightbox) closeLightbox();
    });
  }
  document.addEventListener('keydown', function(event){
    if (!lightbox || lightbox.getAttribute('aria-hidden') === 'true') return;
    if (event.key === 'Escape') closeLightbox();
    if (event.key !== 'Tab') return;

    var focusable = getFocusableElements();
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();
